import { render, staticRenderFns } from "./BidMore.vue?vue&type=template&id=5180a156&scoped=true"
import script from "./BidMore.vue?vue&type=script&lang=js"
export * from "./BidMore.vue?vue&type=script&lang=js"
import style0 from "./BidMore.vue?vue&type=style&index=0&id=5180a156&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5180a156",
  null
  
)

export default component.exports